export default __webpack_public_path__ + "static/media/logoAV.f713557e.svg";